import { render, staticRenderFns } from "./yiMiaoUpdata.vue?vue&type=template&id=1d85dde4&"
import script from "./yiMiaoUpdata.vue?vue&type=script&lang=js&"
export * from "./yiMiaoUpdata.vue?vue&type=script&lang=js&"
import style0 from "./yiMiaoUpdata.vue?vue&type=style&index=0&id=1d85dde4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports